import { render, staticRenderFns } from "./attrConf.vue?vue&type=template&id=8dfd63bc&scoped=true&"
import script from "./attrConf.vue?vue&type=script&lang=js&"
export * from "./attrConf.vue?vue&type=script&lang=js&"
import style0 from "./attrConf.vue?vue&type=style&index=0&id=8dfd63bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfd63bc",
  null
  
)

export default component.exports